import React from 'react';

import Events from '@/pages/Common/Events';
import ViewEvent from '@/pages/Common/Events/ViewEvent';
import Glossary from '@/pages/Common/Glossary';
import Watch from '@/pages/Common/Glossary/Watch';
import Notifications from '@/pages/Common/Notifications';
import DashboardLayout from '@components/templates/layouts/Outlet/DashboardLayout';

const Painel = React.lazy(() => import('pages/Admin/Painel'));
const EnterpriseDetails = React.lazy(() => import('pages/Common/EnterpriseDetails'));
const Error404 = React.lazy(() => import('pages/Errors/404'));

const SupervisorRoutes = {
    path: '/supervisor',
    element: <DashboardLayout />,
    children: [
        // {
        //     path: '/supervisor/painel/:mainTab?',
        //     element: <Painel />
        // },
        {
            path: '/supervisor/empresa/:tabValue?/:id?/:tab?/:modelId?',
            element: <EnterpriseDetails />
        },
        {
            path: '/supervisor/glossario',
            element: <Glossary />
        },
        {
            path: '*',
            element: <Error404 />
        },
        {
            path: '/supervisor/glossario/assistir/:id',
            element: <Watch />
        },
        {
            path: '/supervisor/encontros-ao-vivo',
            element: <Events />
        },
        {
            path: '/supervisor/encontros-ao-vivo/:id',
            element: <ViewEvent />
        },
        {
            path: '/supervisor/notificacoes',
            element: <Notifications />
        }
    ]
};
export default SupervisorRoutes;
